<div class="app-shell" [class.has-sidebar]="data.is_logged_in">
  <app-top-navbar></app-top-navbar>
  <main class="main-content">
    @if (data.is_logged_in && data.supplier_implementation) {
      <div class="save-bar">
        <span class="save-status-text">{{ data.save_status }}</span>
        <button class="btn btn-sm btn-primary" (click)="data.saveImplementation()">
          <i class="fa-solid fa-floppy-disk"></i> Save
        </button>
      </div>
    }
    <router-outlet></router-outlet>
  </main>
</div>
